import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './auth.scss';

export function IntermediatePage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Ensure any session-related state is reset (if applicable)
    sessionStorage.removeItem('showRegistrationPrompt'); 
  }, []);

  const handleLogin = () => navigate('/login', { replace: true });
  const handleRegister = () => navigate('/register', { replace: true });

  return (
    <div className="intermediate-container">
      <div className="intermediate-content">
        <h1>Session Complete! 🎯</h1>
        <p className="session-message">
          Great work on completing your session! To save your progress and access more features:
        </p>
        <div className="auth-options">
          <button onClick={handleLogin} className="auth-button login">
            Login to Your Account
          </button>
          <button onClick={handleRegister} className="auth-button register">
            Create New Account
          </button>
        </div>
      </div>
    </div>
  );
}
